var _excluded = ["generator"], _excluded2 = ["headers"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
      o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import "@shein-aidc/basis-mini-ua-parser";
var base_field = {
  app_name: "",
  timestamp: "",
  local_time: "",
  session_id: "",
  member_id: "",
  sdk_version: "",
  network_type: "",
  device_id: "",
  device_level: "",
  device_type: "",
  device_model: "",
  device_brand: "",
  browser_name: "",
  browser_versions: "",
  os_versions: "",
  os_name: "",
  language: "",
  sub_site: "",
  money_type: "",
  user_agent: "",
  referer: ""
};
var log_field = _objectSpread(_objectSpread({}, base_field), {}, {
  level: "INFO",
  tag: "",
  message: "",
  params: {}
});
var version = "1.1.43";
var getJSON = function getJSON2(data) {
  if (!data) {
    return "";
  }
  try {
    return JSON.parse(data);
  } catch (e) {
    return {};
  }
};
var ClientHttp = /* @__PURE__ */ function() {
  function ClientHttp2() {
    _classCallCheck(this, ClientHttp2);
  }
  return _createClass(ClientHttp2, [{
    key: "http",
    value: function http(params) {
      if (!params.data) {
        params.data = params.params || {};
      }
      this.fetch(params);
    }
  }, {
    key: "fetch",
    value: function(_fetch) {
      function fetch2(_x) {
        return _fetch.apply(this, arguments);
      }
      fetch2.toString = function() {
        return _fetch.toString();
      };
      return fetch2;
    }(function(para) {
      if (typeof fetch !== "function") {
        this.ajax(para);
        return;
      }
      if (!para.url)
        return console.log("[client-http] fetch url is required");
      var method = para.method || "GET";
      if (!para.method) {
        method = para.data ? "POST" : "GET";
      }
      var headers = para.headers || {};
      try {
        typeof para.beforeRequest === "function" && para.beforeRequest({
          url: para.url,
          method,
          headers,
          data: para.data
        });
      } catch (error) {
        console.log("[client-http] beforeRequest error: ", error);
      }
      var params = {
        method,
        headers
      };
      if (method === "POST") {
        params["body"] = JSON.stringify(para.data);
      }
      if (method === "GET") {
        para.url = para.url + "?" + this.formatParams(para.data);
      }
      fetch(para.url, params).then(function(response) {
        if (response.status >= 200 && response.status < 300 || response.status == 304) {
          return response.text();
        } else {
          return Promise.reject(response);
        }
      }).then(function(data) {
        var _para$success;
        (_para$success = para.success) === null || _para$success === void 0 || _para$success.call(para, getJSON(data));
      })["catch"](function(error) {
        var _para$error;
        (_para$error = para.error) === null || _para$error === void 0 || _para$error.call(para, error);
      });
    })
  }, {
    key: "ajax",
    value: function ajax(para) {
      if (!para.url)
        return console.log("[client-http] fetch url is required");
      var xhr = this.xhr();
      if (!xhr)
        return false;
      var method = para.method || "GET";
      if (!para.method) {
        method = para.data ? "POST" : "GET";
      }
      if (method === "GET") {
        para.url = para.url + "?" + this.formatParams(para.data);
      }
      xhr.open(method, para.url, true);
      if (para.success || para.error) {
        xhr.onreadystatechange = function() {
          try {
            if (xhr.readyState == 4) {
              if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304) {
                var _para$success2;
                (_para$success2 = para.success) === null || _para$success2 === void 0 || _para$success2.call(para, getJSON(xhr.responseText));
              } else {
                var _para$error2;
                (_para$error2 = para.error) === null || _para$error2 === void 0 || _para$error2.call(para, getJSON(xhr.responseText));
              }
              xhr.onreadystatechange = null;
              xhr.onload = null;
            }
          } catch (e) {
            xhr.onreadystatechange = null;
            xhr.onload = null;
          }
        };
      }
      var headers = para.headers;
      try {
        typeof para.beforeRequest === "function" && para.beforeRequest({
          url: para.url,
          method,
          headers,
          data: para.data
        });
      } catch (error) {
        console.log("[client-http] beforeRequest error: ", error);
      }
      for (var i in headers) {
        var v = headers[i];
        if (!v)
          continue;
        xhr.setRequestHeader(i, v);
      }
      xhr.send(JSON.stringify(para.data));
    }
  }, {
    key: "xhr",
    value: function xhr() {
      if (typeof XMLHttpRequest !== "undefined") {
        return new XMLHttpRequest();
      } else {
        return null;
      }
    }
  }, {
    key: "formatParams",
    value: function formatParams(data) {
      var search = [];
      for (var i in data || {}) {
        var v = data[i];
        if (typeof v == "undefined")
          continue;
        search.push("".concat(i, "=").concat(encodeURIComponent(v)));
      }
      return search.join("&");
    }
  }]);
}();
var getNetworkType = function getNetworkType2() {
  var _navigator, _navigator2, _navigator3;
  var network_effective_type = "";
  var connection_info = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.connection) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.mozConnection) || ((_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.webkitConnection);
  if (connection_info && (connection_info === null || connection_info === void 0 ? void 0 : connection_info.effectiveType) !== void 0) {
    network_effective_type = connection_info === null || connection_info === void 0 ? void 0 : connection_info.effectiveType;
  }
  return network_effective_type;
};
var getDeviceClass = function getDeviceClass2() {
  var userAgent = navigator.userAgent.toLowerCase();
  if (/mobile|ip(hone|od)|midp|rv:1.2.3.4|ucweb|android|blackberry|iemobile|windows ce|windows mobile/.test(userAgent)) {
    return "Phone";
  } else if (/ipad|tablet/.test(userAgent)) {
    return "Tablet";
  } else {
    return "Desktop";
  }
};
var getClientSimpleCommonField = function getClientSimpleCommonField2() {
  var deviceClass = getDeviceClass();
  return _objectSpread(_objectSpread({}, log_field), {}, {
    sdk_version: version,
    user_agent: navigator.userAgent,
    network_type: getNetworkType(),
    referer: encodeURIComponent(document.referrer) || "",
    device_level: deviceClass == "Phone" ? "0" : deviceClass == "Desktop" ? "1" : deviceClass == "Tablet" ? "2" : "3"
  });
};
var getServiceCommonField = function getServiceCommonField2() {
  return _objectSpread(_objectSpread({}, log_field), {}, {
    sdk_version: version
  });
};
var getLoggerHttp = function getLoggerHttp2() {
  var loggerHttp = new ClientHttp();
  return loggerHttp.http.bind(loggerHttp);
};
var stringifyLogParams = function stringifyLogParams2(data, unStringNumber) {
  if (_typeof(data) !== "object")
    return data;
  try {
    data = JSON.parse(JSON.stringify(data));
    for (var key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        var value = data[key];
        var keyType = _typeof(value);
        switch (keyType) {
          case "object":
            data[key] = JSON.stringify(value).slice(0, 500);
            break;
          case "number":
            if (!unStringNumber)
              data[key] = String(value);
            break;
        }
      }
    }
    return data;
  } catch (error) {
    return data;
  }
};
var getHttpFetch = function getHttpFetch2(generator) {
  var isClientEnv = typeof window !== "undefined";
  return typeof generator === "function" ? generator() : isClientEnv ? getLoggerHttp() : function(data) {
    import("axios").then(function(_ref) {
      var axios = _ref["default"];
      return axios.request(data);
    })["catch"](function(error) {
      return console.log("[@/monitor/http] node \u73AF\u5883\u53D1\u8D77\u4E86\u8BF7\u6C42\uFF0C\u53D1\u751F\u4E86\u9519\u8BEF\uFF1A", error);
    });
  };
};
var getReportHost = function getReportHost2(serverType, env) {
  var host = "";
  switch (serverType) {
    case "eur":
      {
        var URL = {
          production: "https://www.srmdata-eur.com",
          gray: "https://www.srmdata-eur.com",
          localhost: "https://srmdata-eur.abc-test.sheincorp.cn",
          debug: "https://srmdata-eur.abc-test.sheincorp.cn"
        };
        host = URL[env];
      }
      break;
    case "us":
      {
        var _URL = {
          production: "https://www.srmdata-us.com",
          gray: "https://www.srmdata-us.com",
          localhost: "https://srmdata-us.abc-test.sheincorp.cn",
          debug: "https://srmdata-us.abc-test.sheincorp.cn"
        };
        host = _URL[env];
      }
      break;
    default:
      {
        var _URL2 = {
          production: "https://www.srmdata.com",
          gray: "https://www.srmdata.com",
          localhost: "https://srmdata.abc-test.sheincorp.cn",
          debug: "https://srmdata.abc-test.sheincorp.cn"
        };
        host = _URL2[env];
      }
      break;
  }
  return host;
};
var assignFields = function assignFields2(data, commonFields) {
  var timestamp = data.timestamp || new Date().getTime();
  var log_time = {
    timestamp: String(timestamp),
    local_time: new Date(timestamp).toLocaleString()
  };
  var fields = JSON.parse(JSON.stringify(commonFields));
  for (var key in data) {
    var value = data[key];
    if (_typeof(value) === "object") {
      if (_typeof(fields[key]) === "object") {
        fields[key] = _objectSpread(_objectSpread({}, fields[key]), value);
      } else {
        fields[key] = value;
      }
    } else {
      fields[key] = value;
    }
  }
  if (fields.params) {
    fields.params = stringifyLogParams(fields.params);
  }
  if (fields.tags) {
    fields.tags = stringifyLogParams(fields.tags || {}, true);
  }
  return _objectSpread(_objectSpread({}, fields), log_time);
};
var generateMonitorReportTools = function generateMonitorReportTools2(injectBaseField) {
  return function(initFields, config) {
    if (!initFields.app_name) {
      throw new Error("app_name is required");
    }
    var isClientEnv = typeof window !== "undefined";
    var baseField = typeof injectBaseField === "function" ? injectBaseField() : {};
    var commonFields = _objectSpread(_objectSpread({}, baseField), initFields);
    var host = getReportHost((config === null || config === void 0 ? void 0 : config.server_type) || "central", initFields.environment || "debug") || getReportHost("central", "debug");
    var report = function report2(params) {
      var _ref2 = (config === null || config === void 0 ? void 0 : config["monitor-http-plugin"]) || {}, generator = _ref2.generator, options = _objectWithoutProperties(_ref2, _excluded);
      var httpFetch = getHttpFetch(generator);
      var _ref3 = options || {}, headers = _ref3.headers, opts = _objectWithoutProperties(_ref3, _excluded2);
      httpFetch === null || httpFetch === void 0 || httpFetch(_objectSpread(_objectSpread({
        method: "POST",
        headers: _objectSpread(_objectSpread({}, headers), {}, {
          "DS-ACCESS-TOKEN": "4bc3a2dd3549401b817438eede7e78da",
          "DS-ACCESS-SITE": commonFields.app_name || "shein",
          "Content-Type": "application/json"
        })
      }, params), opts));
    };
    var url = "".concat(isClientEnv ? "".concat(location.protocol, "//").concat(String(host).replace(/http(s?):\/\//, "")) : host);
    return {
      log: function log(data) {
        var level = "INFO";
        var _data = Array.isArray(data) ? data.map(function(item) {
          return assignFields(_objectSpread({
            level
          }, item), commonFields);
        }) : [assignFields(_objectSpread({
          level
        }, data), commonFields)];
        report === null || report === void 0 || report({
          url: "".concat(url, "/app-track/log-info"),
          data: {
            data: _data
          }
        });
      },
      metric: function metric(data) {
        var config2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (config2.random) {
          var random = Math.random();
          if (random > config2.random) {
            return;
          }
        }
        var value = 1;
        var _data = Array.isArray(data) ? data.map(function(item) {
          return assignFields(_objectSpread({
            value
          }, item), commonFields);
        }) : [assignFields(_objectSpread({
          value
        }, data), commonFields)];
        report === null || report === void 0 || report({
          url: "".concat(url, "/app-track/metric-info"),
          data: {
            data: _data
          }
        });
      }
    };
  };
};
var generateMonitorReport = generateMonitorReportTools(function() {
  var isClientEnv = typeof window !== "undefined";
  return isClientEnv ? getClientSimpleCommonField() : getServiceCommonField();
});
export { generateMonitorReport };
